import React, { FC } from 'react';

export const SelectWrapper: FC<React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	...props
}) => {
	return (
		<div
			style={{
				display: 'flex',
				width: 153,
				height: 56,
				backgroundColor: 'white',
				marginRight: 24,
			}}
			{...props}
		>
			{children}
		</div>
	);
};
